import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

export default function PopoverHelp({content, children}) {
    return (
        <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
                <div className="popover-help-container">
                    <div className="popover-help" {...bindTrigger(popupState)}>
                        <i className="fas fa-info-circle"></i>
                    </div>
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                    >
                        <Box p={2}>
                            {content && (<Typography>{content}</Typography>)}
                            {children && children}
                        </Box>
                    </Popover>
                </div>
            )}
        </PopupState>
    );
}